<template>
  <div class="custom-basic">
    <highcharts
      :constructorType="'stockChart'"
      class="hc"
      :options="chartOptions()"
      ref="chart"
    ></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";

export default {
  props: ["data"],
  components: {
    highcharts: Chart,
  },
  methods: {
    chartOptions() {
      let chart = {
        chart: {
          height: 400,
          style: {
            fontFamily: "Mitr",
          },
        },
        colors: this.data.colors,
        title: {
          useHTML: true,
          text: this.data.title.text,
        },
        subtitle: this.data.subtitle,
        rangeSelector: {
          selected: 1,
        },
        tooltip: this.data.tooltip,
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
          column: {
            stacking: this.data.stacking,
            dataLabels: {
              enabled: true,
            },
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        legend: {
          enabled: true,
        },
        series: this.data.data,
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                chart: {
                  height: 300,
                },
                subtitle: {
                  text: null,
                },
                navigator: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
      return chart;
    },
  },
};
</script>

<style scoped>
.custom-basic >>> .highcharts-range-selector-group {
  display: none;
}
</style>
